var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.073 2.933C6.073 1.865 6.94 1 8.006 1h5.877a1.933 1.933 0 1 1 0 3.866H8.006a1.933 1.933 0 0 1-1.933-1.933zm9.743 26.134a1.933 1.933 0 0 1 1.933-1.933h5.875a1.933 1.933 0 1 1 0 3.866h-5.876a1.933 1.933 0 0 1-1.934-1.933zM7.27 9.454a1.933 1.933 0 1 0 1.326 3.632L24.43 7.305a1.933 1.933 0 1 0-1.326-3.632L7.27 9.454zM6.119 19.51a1.933 1.933 0 0 1 1.153-2.478l15.834-5.781a1.933 1.933 0 0 1 1.326 3.632L8.596 20.663a1.933 1.933 0 0 1-2.478-1.153zm1.153 5.1a1.933 1.933 0 1 0 1.326 3.63l15.834-5.78a1.933 1.933 0 1 0-1.326-3.632L7.27 24.608z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/AUCTION.0669294a70f1ed757c1be93319280ebd.svg";
export { ForwardRef as ReactComponent };